export default [ // 健康有益
  // {
  //   path: '/health/record',
  //   name: 'RECORD',
  //   component: () => import('@/views/health/record')
  // },
  // {
  //   path: '/health/questionnaire',
  //   name: 'QUESTIONNAIRE',
  //   component: () => import('@/views/health/questionnaire')
  // },
  // {
  //   path: '/health/report',
  //   name: 'REPORT',
  //   component: () => import('@/views/health/report')
  // }
  {
    path: '/health', // 健康数据tab
    name: 'Health',
    component: () => import('@/views/health/index'),
    meta: {
      loginNo: true,
      title: '健康数据'
    }
  },
  {
    path: '/health/historyData', // 全部健康数据
    name: 'HealthHistoryData',
    component: () => import('@/views/health/historyData/index'),
    meta: {
      loginNo: true,
      title: '全部数据'
    }
  },
  {
    path: '/hardwareDevice/list', // 硬件设备列表
    name: 'HardwareDeviceList',
    component: () => import('@/views/hardwareDevice/list'),
    meta: {
      title: '选择设备'
    }
  },
  {
    path: '/hardwareDevice/middle', // 设备中间页
    name: 'HardwareDeviceMiddle',
    component: () => import('@/views/hardwareDevice/middle')
  },
  {
    path: '/health-data',
    name: 'HEALTHDATA',
    meta: {
      title: '健康数据'
    },
    component: () => import('@/views/health-data/index.vue')
  },
  {
    path: '/health-data/upload',
    name: 'HEALTHDATAUPLOAD',
    meta: {
      title: '健康数据上传'
    },
    component: () => import('@/views/health-data/upload/index.vue')
  },
  {
    path: '/portal', // 本地
    name: 'portal',
    component: () => import('@/views/local/portal'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/selecArea', // 选择地区
    name: 'selecArea',
    component: () => import('@/views/local/selecArea'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/measure/intro',
    name: 'MeasureInfo',
    component: () => import('@/views/measure/intro')
  },
  {
    path: '/measure/data',
    name: 'MeasureData',
    component: () => import('@/views/measure/data/index'),
    meta: {
      title: '同步中'
    }
  },
  {
    path: '/measure/preview',
    name: 'MeasurePreview',
    component: () => import('@/views/measure/preview/index')
  },
  {
    path: '/health/drinkWater',
    name: 'drinkWater',
    component: () => import('@/views/health/drinkWater/index'),
    meta: {
      title: '喝水提醒',
      keepAlive: true
    }
  },
  {
    path: '/health/drinkWater/shortcuts',
    name: 'drinkWaterShortcuts',
    component: () => import('@/views/health/drinkWater/shortcuts/index'),
    meta: {
      title: '快捷记录'
    }
  },
  {
    path: '/health/drinkWater/remind-set',
    name: 'drinkWaterRemindSet',
    component: () => import('@/views/health/drinkWater/remind-set/index'),
    meta: {
      title: '设置提醒'
    }
  },
  {
    path: '/health/drinkWater/drink-list',
    name: 'drinList',
    component: () => import('@/views/health/drinkWater/drink-list/index'),
    meta: {
      title: '饮品含水量'
    }
  },
  {
    path: '/health/drinkWater/statistics',
    name: 'drinkWaterStatistics',
    component: () => import('@/views/health/drinkWater/statistics/index'),
    meta: {
      title: '喝水统计'
    }
  },
  {
    path: '/health/type-card',
    name: 'type-card',
    component: () => import('@/views/health/type-card/index'),
    meta: {
      title: '编辑卡片'
    }
  },
  {
    path: '/health/sports/indicator-detail/:indicator?',
    name: 'sports-indicator-detail',
    component: () => import('@/views/health/sports/indicator-detail/index')
  },
  {
    path: '/health/indicator-target-set',
    name: 'indicator-target-set',
    component: () => import('@/views/health/indicator-target-set/index'),
    meta: {
      title: '调整目标'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/health.js